import { render } from "./InputGender.vue?vue&type=template&id=0ded78d3"
import script from "./InputGender.vue?vue&type=script&lang=js"
export * from "./InputGender.vue?vue&type=script&lang=js"
script.render = render

export default script